export enum CheckoutStep {
  Contact = 'CONTACT',
  DeliveryAddress = 'DELIVERY_ADDRESS',
  ShippingDetails = 'SHIPPING_DETAILS',
  ChangeDetails = 'CHANGE_DETAILS',
}

export enum DataTypesEnums {
  TYPE_STRING = 'TYPE_STRING',
  TYPE_NUMBER = 'TYPE_NUMBER',
}

export default CheckoutStep;
